import Vue from 'vue'
/* eslint-disable no-unused-vars */
import {Component, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {
  USER_ACTION_TYPE, USER_INFO,
  USER_INFO_FIELD,
  USER_INFO_UPDATE,
  USER_MODULE_NAMESPACE,
  USER_RESET_USER
} from '../../store/user/user-types.store'
import {IUserDetails} from '../../models/user'
// @ts-ignore
import {ActivityStatus} from '@/common/enums'
import {
  PROFILE_MODULE_NAMESPACE,
  PROFILE_RECORD_MEMBER,
  PROFILE_RESET_MEMBER, PROFILE_RESET_MEMBERS,
  PROFILE_SET_MEMBER_PARAMETER, PROFILE_SET_PAGINATION_PAGE,
  PROFILE_SET_TICKET_CLOSING_REASON,
  PROFILE_SET_TICKET_REASON,
  PROFILE_SET_TICKET_SUBSTATUS,
  PROFILE_UPDATE_MEMBER,
  PROFILE_UPDATE_SIGNATURE
} from '../../store/profile/profile-types.store'
import {IMemberParameter} from '../../models/profile/member.parameter'
import {CrudStatus} from '../../common/enums'
import {TranslateResult} from 'vue-i18n'
import {
  AM_ATTACHMENT_TYPE_UPDATE,
  AM_CHAR_PB_UPDATE,
  AM_MODULE_NAMESPACE, AM_RECORD_AT_ATTRIBUTE,
  AM_RECORD_ATTACHMENT_TYPE,
  AM_RECORD_ATTRIBUTE,
  AM_RECORD_CHAR_PB,
  AM_RESET_ATTACHMENT_TYPE_TO_EDIT,
  AM_RESET_ATTRIBUTE_TO_EDIT,
  AM_RESET_CHAR_PB_TO_EDIT,
  AM_SET_ATTACHMENT_TYPE_BY_FIELD,
  AM_SET_CHAR_PB_BY_FIELD,
  AM_UPDATE_AT_ATTRIBUTE,
  AM_UPDATE_ATTRIBUTE
} from '../../store/agency-management/am-types.store'
import { eventBus } from '../../main'
import { MAINTENANCE_MODULE_NAMESPACE, MAINTENANCE_TEMPLATE_INIT_FIELDS, MAINTENANCE_TEMPLATE_PATCH_UPDATE, MAINTENANCE_TEMPLATE_POST_CREATE } from '../../store/maintenance'
import { ITemplateMaintenance } from '../../models/maintenance/template-maintenance.model'
import { ProfileService } from '../../services'

const UserStore = namespace(USER_MODULE_NAMESPACE)
const ProfileStore = namespace(PROFILE_MODULE_NAMESPACE)
const AMStore = namespace(AM_MODULE_NAMESPACE)
const MaintenanceStore = namespace(MAINTENANCE_MODULE_NAMESPACE);

@Component({
  components: {
    'profile-update-modal': async () => import('./components/profile-update-modal/ProfileUpdateModal.vue'),
    'profile-child-account': async () => import('./profile-child-account/ProfileChildAccount.vue'),
    'profile-child-notification': async () => import('./profile-child-notification/ProfileChildNotification.vue'),
    'profile-nav-bar': async () => import('./components/profile-sidebar/ProfileSidebar.vue'),
    'profile-management': async () => import('./team-management/TeamManagement.vue'),
    'profile-modal-vertical': async () => import('./components/profile-modal-vertical/ProfileModalVertical.vue'),
    'profile-signature-modal-vertical': async () => import('./components/profile-signature-modal-vertical/ProfileSignatureModalVertical.vue'),
    'am-char-problem-modal-vertical': async () => import('./components/am-char-problem-modal-vertical/AMCharProblemModalVertical.vue'),
    'am-attribute-modal-vertical': async () => import('./components/am-attribute-modal-vertical/AMAttributeModalVertical.vue'),
    'am-attachment-type-modal-vertical': async () => import('./components/am-attachment-type-modal-vertical/AMAttachmentTypeModalVertical.vue'),
    'template-maintenance-modal': async () => import('./components/template-maintenance-modal-vertical/TemplateMaintenanceModalVertical.vue'),
    'closing-reasons-modal': async () => import('./components/closing-reasons-modal-vertical/ClosingReasonsModalVertical.vue'),
    'ticket-substatus-modal': async () => import('./components/ticket-substatus-modal-vertical/TicketSubstatusModalVertical.vue'),
    'ticket-reason-modal': async () => import('./components/ticket-reason-modal-vertical/TicketReasonModalVertical.vue')
  }
})
class ProfileContainer extends Vue {
  /* eslint-disable no-undef */
  @UserStore.Getter userInfo: IUserDetails;
  @UserStore.Getter activityStatus: ActivityStatus;
  @ProfileStore.Getter memberParameter: IMemberParameter
  @UserStore.Getter userActionType: string

  @ProfileStore.Getter profileCrudActionStatus: CrudStatus
  @Watch('profileCrudActionStatus')
  onProfileCrudActionChange (newVal: CrudStatus) {
    if (newVal === CrudStatus.Update) this.dtProfileModalVisible = true
  }

  @UserStore.Getter userCrudActionStatus: CrudStatus
  @Watch('userCrudActionStatus')
  onUserCrudActionchange (newVal: CrudStatus) {
    if (newVal === CrudStatus.Update) this.dtProfileModalVisible = true
  }

  @AMStore.Getter amCrudActionStatus: CrudStatus
  @Watch('amCrudActionStatus')
  onAMCrudActionchange (newVal: CrudStatus) {
    if (newVal === CrudStatus.Update || newVal === CrudStatus.Create) {
      this.dtProfileModalVisible = true
    }
  }


  @ProfileStore.Mutation(PROFILE_SET_TICKET_CLOSING_REASON)
  storeSetClosingReason: (payload: {id?:number, name?:string, description?:string, disabled?:boolean}) => void;
  @ProfileStore.Getter closingReason: {id?:number, name?:string, description?:string, disabled?:boolean}

  @ProfileStore.Mutation(PROFILE_SET_TICKET_SUBSTATUS)
  storeSetTicketSubstatus: (payload: {id?:number, name?:string, disabled?:boolean}) => void;
  @ProfileStore.Getter ticketSubstatus: {id?:number, name?:string, disabled?:boolean}

  @ProfileStore.Mutation(PROFILE_SET_TICKET_REASON)
  storeSetTicketReason: (payload: {id?:number, name?:string, disabled?:boolean}) => void;
  @ProfileStore.Getter ticketReason: {id?:number, name?:string, disabled?:boolean}

  @AMStore.Getter characterProblemToEdit: any
  @AMStore.Getter attachmentTypeToEdit: any
  @AMStore.Getter characterProblem: any
  @AMStore.Getter attachmentType: any

  @ProfileStore.Mutation(PROFILE_SET_MEMBER_PARAMETER)
  storeSetMemberParameter: (payload: IMemberParameter) => void

  @UserStore.Mutation(USER_INFO_FIELD)
  storeSetUserInfo;

  @UserStore.Mutation(USER_ACTION_TYPE)
  storeSetUserActionType: (type: string) => void

  @AMStore.Mutation(AM_SET_CHAR_PB_BY_FIELD)
  storeSetCharPbByValue: (payload: any) => void

  @AMStore.Mutation(AM_SET_ATTACHMENT_TYPE_BY_FIELD)
  storeSetAttachmentTypeByValue: (payload: any) => void

  @ProfileStore.Action(PROFILE_RESET_MEMBER)
  storeResetMember: () => void

  @ProfileStore.Action(PROFILE_RECORD_MEMBER)
  storeRecordMember: () => Promise<any>

  @ProfileStore.Action(PROFILE_UPDATE_MEMBER)
  storeUpdateMember: (payload?: { own: boolean }) => Promise<any>

  @ProfileStore.Action(PROFILE_UPDATE_SIGNATURE)
  storeUpdateSignature: (payload?: { signature: string }) => Promise<any>

  @UserStore.Action(USER_INFO_UPDATE)
  storeUpdateUserInfo: () => Promise<any>

  @UserStore.Action(USER_RESET_USER)
  storeResetUser: () => void

  @UserStore.Action(USER_INFO)
  storeGetUserInfo: () => Promise<IUserDetails>;

  @AMStore.Action(AM_RECORD_CHAR_PB)
  storeRecordCharPb: () => Promise<any>

  @AMStore.Action(AM_RECORD_ATTACHMENT_TYPE)
  storeRecordAttachmentType: () => Promise<any>

  @AMStore.Action(AM_RESET_CHAR_PB_TO_EDIT)
  storeResetCharPb: () => void

  @AMStore.Action(AM_RESET_ATTACHMENT_TYPE_TO_EDIT)
  storeResetAttachmentType: () => void

  @AMStore.Action(AM_RESET_ATTRIBUTE_TO_EDIT)
  storeResetAttribute: () => void

  @AMStore.Action(AM_CHAR_PB_UPDATE)
  storeUpdateCharPb: () => Promise<any>

  @AMStore.Action(AM_ATTACHMENT_TYPE_UPDATE)
  storeUpdateAttachmentType: () => Promise<any>

  @AMStore.Action(AM_RECORD_ATTRIBUTE)
  storeRecordAttribute: () => Promise<any>

  @AMStore.Action(AM_UPDATE_ATTRIBUTE)
  storeUpdateAttribute: () => Promise<any>

  @AMStore.Action(AM_RECORD_AT_ATTRIBUTE)
  storeRecordATAttribute: () => Promise<any>

  @AMStore.Action(AM_UPDATE_AT_ATTRIBUTE)
  storeUpdateATAttribute: () => Promise<any>

  @ProfileStore.Action(PROFILE_RESET_MEMBERS)
  storeResetMembers: () => Promise<boolean>
  @ProfileStore.Mutation(PROFILE_SET_PAGINATION_PAGE)
  storeSetPaginationPage: (page: number) => void


  @MaintenanceStore.Action(MAINTENANCE_TEMPLATE_POST_CREATE)
  storeCreateTemplateMaintenance: () => Promise<any>

  @MaintenanceStore.Action(MAINTENANCE_TEMPLATE_PATCH_UPDATE)
  storeUpdateTemplateMaintenance: (id:string) => Promise<any>

  @MaintenanceStore.Mutation(MAINTENANCE_TEMPLATE_INIT_FIELDS)
  storeTemplateMaintenanceInitFields: () => void;

  dtTitle: string;
  modal: any;
  loadUpdateAccount: boolean;
  snackbar: { open: boolean, timeout: number, text: string, color: string };
  dtProfileModalVisible: boolean
  dtTemplateMaintenanceModalVisible: boolean
  dtClosingReasonsModalVisible: boolean
  dtTicketSubstatusModalVisible: boolean
  dtTicketReasonsModalVisible: boolean
  dtIsRecording: boolean
  dtErrorModalVisible: boolean
  dtError: any
  // canViewAddMember: boolean
  profileAction: any
  newSignature: string
  keyword:string

  templateMaintenanceData:any
  isUpdateTemplateMaintenance:boolean

  // ==== closing reasons
  isUpdateClosingReason:boolean
  profileService:ProfileService
  loadingDisabled:boolean

  // === ticket substatus
  isUpdateTicketSubstatus:boolean

  isUpdateTicketReason:boolean

  /**
   *
   */
  constructor () {
    super()
    this.dtTitle = null
    this.dtProfileModalVisible = false
    this.dtTemplateMaintenanceModalVisible = false
    this.dtClosingReasonsModalVisible = false
    this.dtTicketSubstatusModalVisible = false
    this.dtTicketReasonsModalVisible = false
    this.dtIsRecording = false
    this.dtErrorModalVisible = false
    this.dtError = null
    // this.canViewAddMember = false
    this.profileAction = {
      Profile: 'PROFILE',
      Signature: 'SIGNATURE',
      CharPb: 'CHAR_PB',
      Attribute: 'ATTRIBUTE',
      ATAttribute: 'AT_ATTRIBUTE',
      AttachmentType: 'ATTACHMENT_TYPE'
    }
    this.newSignature = null

    this.modal = {
      display: false,
      title: '',
      msg: '',
      save: () => {
      },
      params: {}
    }
    this.loadUpdateAccount = false
    this.snackbar = {
      open: false,
      timeout: 3000,
      text: '',
      color: 'primaryDark'
    }
    this.keyword = ''

    this.templateMaintenanceData = {}
    this.isUpdateTemplateMaintenance = false

    this.isUpdateClosingReason = false
    this.profileService = new ProfileService()
    this.loadingDisabled = false

    this.isUpdateTicketSubstatus = false
    this.isUpdateTicketReason = false
  }

  mounted () {
    const anchor = this.$route.hash
    this.$nextTick(() => {
      if (anchor && document.querySelector(anchor)) {
        location.href = anchor
      }
    })
  }

  beforeMount()
  {
    eventBus.$on('EDIT_TEMPLATE_MAINTENANCE', (template:ITemplateMaintenance)=>{
      this.templateMaintenanceData = template
      this.isUpdateTemplateMaintenance = true
      this.dtTemplateMaintenanceModalVisible = true
    })

    eventBus.$on('EDIT_CLOSING_REASON', (data:any)=>{
      this.isUpdateClosingReason = true
      this.dtClosingReasonsModalVisible = true
    })

    eventBus.$on('EDIT_TICKET_REASON', (data:any)=>{
      this.isUpdateTicketReason = true
      this.dtTicketReasonsModalVisible = true
    })

    eventBus.$on('EDIT_TICKET_SUBSTATUS', (data:any)=>{
      this.isUpdateTicketSubstatus = true
      this.dtTicketSubstatusModalVisible = true
    })
  }

  beforeDestroy(){
    eventBus.$off('EDIT_TEMPLATE_MAINTENANCE')
    eventBus.$off('EDIT_CLOSING_REASON')
    eventBus.$off('EDIT_TICKET_SUBSTATUS')
    eventBus.$off('EDIT_TICKET_REASON')
  }

  get coKeyword () {
    /* const {key} = this.memberParameter
    return key */
    if(this.$route.name === 'agency_management_maintenance_template')
    {
      return this.keyword
    }
    else
    {
      return this.memberParameter.key
    }
  }

  set coKeyword (value: string) {
    /* this.storeSetMemberParameter(
      {current_filter: this.$route.name === 'team-management' ? 'team' : 'external', key: value}
    ) */
    if(this.$route.name === 'agency_management_maintenance_template')
    {
      //console.log('handleSearch templates')
      eventBus.$emit('SEARCH_MAINTENANCE_TEMPLATE',value)
    }else{
      this.storeSetMemberParameter(
        {current_filter: this.$route.name === 'team-management' ? 'team' : 'external', key: value})
    }
  }

  get lblSetting () {
    return {
      ...require('../../locales/profile').default,
      ...require('../../locales/button').default,
      ...require('../../locales/generic-labels').default,
      ...require('../../locales/agency-management').default
    }
  }

  get coTitlePrefix (): string {
    let fn = (this.userInfo.firstname || '')
    let ln = (this.userInfo.lastname || '')
    let ci = (this.userInfo.civility_shorten || '')
    this.dtTitle = `${ci} ${fn} ${ln}`
    return `${fn.substring(0, 1)}${ln.substring(0, 1)}`
  }

  get coIsManagement (): boolean {
    switch (this.$route.path) {
      case '/profile/team-management':
      case '/profile/other-users':
        return JSON.parse(localStorage.getItem('profile'))['add_team_account'] || JSON.parse(localStorage.getItem('profile'))['manage_external_account']
      case '/profile/char-problem':
        return this.$route.meta['manage_agency_char_pb']
      case '/profile/char-problem/' + this.$route.params.id:
        if (!this.characterProblem) return false
        return (this.$route.meta['manage_agency_char_pb'] && this.characterProblem.level === 1)
      case '/profile/attachment-type':
        return this.$route.meta['manage_agency_attachment_type']
      case '/profile/attachment-type/' + this.$route.params.id:
        if (!this.attachmentType) return false
        return this.attachmentType.level === 1 && this.$route.meta['manage_agency_attachment_type']
      case '/profile/maintenance-template':
        return this.$route.meta['manage_maintenance_template']
      case '/profile/ticket-closing-reasons':
        return JSON.parse(localStorage.getItem('agency_management'))['manage_ticket_closure_reason']
      case '/profile/ticket-substatus':
        return JSON.parse(localStorage.getItem('agency_management'))['manage_ticket_substatus']
      case '/profile/ticket-reasons':
        return JSON.parse(localStorage.getItem('agency_management'))['manage_ticket_triggering_cause']
    }
  }

  get modalTitle (): TranslateResult {
    switch (this.userActionType) {
      case this.profileAction.Profile:
      case this.profileAction.Signature:
        return this.isUserUpdateAction ? this.$t(this.lblSetting.profileOwnUpdate)
          : this.isProfileUpdateAction ? this.$t(this.lblSetting.profileMemberUpdate) : this.$t(this.lblSetting.profileMemberCreate)
      case this.profileAction.CharPb:
        if (this.isAMUpdateAction) {
          if (this.characterProblem.level === 2) return this.$t(this.lblSetting.amCharPb2Update)
          return this.$t(this.lblSetting.amCharPbUpdate)
        }
        if (this.$route.path === '/profile/char-problem/' + this.$route.params.id) {
          if (this.$route.meta['char_pb_linked']) return this.$t(this.lblSetting.amCharPb2Create)
        }
        return this.$t(this.lblSetting.amCharPbCreate)
      case this.profileAction.Attribute:
      case this.profileAction.ATAttribute:
        return this.$t(this.lblSetting.amCreateAttributeTitle)
      case this.profileAction.AttachmentType:
        if (this.isAMUpdateAction) {
          if (this.attachmentType.level === 2) return this.$t(this.lblSetting.amCharPb2Update)
          return this.$t(this.lblSetting.amCharPbUpdate)
        }
        if (this.$route.path === '/profile/attachment-type/' + this.$route.params.id) return this.$t(this.lblSetting.amCharPb2Create)
        return this.$t(this.lblSetting.amCharPbCreate)
      default:
        return ''
    }
  }

  get maxWidth (): string {
    if (this.userActionType === this.profileAction.Signature ||
      this.userActionType === this.profileAction.Attribute ||
      this.userActionType === this.profileAction.ATAttribute ||
      this.userActionType === this.profileAction.AttachmentType) return '50vw'
    return '85vw'// `${document.body.clientWidth * 0.85}px`
  }

  get buttonText (): TranslateResult {
    return this.isProfileUpdateAction ? this.$t(this.lblSetting.btnUpdate) : this.$t(this.lblSetting.profileBtnRecord)
  }

  get isProfileUpdateAction (): boolean {
    return this.profileCrudActionStatus === CrudStatus.Update
  }

  get isUserUpdateAction (): boolean {
    return this.userCrudActionStatus === CrudStatus.Update
  }

  get isAMUpdateAction (): boolean {
    return this.amCrudActionStatus === CrudStatus.Update
  }
  get searchVisible(): boolean {
    if(this.$route.name === 'team-management' || this.$route.name === 'other-users' || this.$route.name === 'agency_management_maintenance_template' ) return true;
    return false
  }
  handleAdd () {
    if(this.$route.name === 'agency_management_maintenance_template')
    {
      this.dtTemplateMaintenanceModalVisible = true
    }
    else if(this.$route.name === 'ticket_closing_reason')
    {
      this.dtClosingReasonsModalVisible = true
    }
    else if(this.$route.name === 'ticket_substatus')
    {
      this.dtTicketSubstatusModalVisible = true
    }
    else if(this.$route.name === 'ticket_reasons')
    {
      this.dtTicketReasonsModalVisible = true
    }
    else
    {
      if (this.$route.path.startsWith('/profile/char-problem')) {
        if (!this.characterProblem || this.characterProblem.level === 1) this.storeSetUserActionType(this.profileAction.CharPb)
        else if (this.characterProblem.level === 2) this.storeSetUserActionType(this.profileAction.Attribute)
      } else if (this.$route.path.startsWith('/profile/attachment-type')) {
        this.storeSetUserActionType(this.profileAction.AttachmentType)
      } else {
        this.storeSetUserActionType(this.profileAction.Profile)
      }
      this.dtProfileModalVisible = true
    }
  }

  handleChangeSignature (val) {
    this.newSignature = val
  }

  handleBeforeModalClose () {
    console.log('handleBeforeModalClose')
    this.$nextTick(() => {
      this.storeResetMember()
      this.storeResetUser()
      this.storeResetCharPb()
      this.storeResetAttachmentType()
      this.storeResetAttribute()
      this.storeTemplateMaintenanceInitFields()
      this.storeClosingReasonReset()
      this.storeTicketSubstatusReset()
      this.storeTicketReasonReset()
    })
    this.dtProfileModalVisible = false
    this.templateMaintenanceData = null
    this.isUpdateTemplateMaintenance = false

  }

  storeTicketSubstatusReset()
  {
    this.storeSetTicketSubstatus({id:null, name:null, disabled:false})
    this.dtTicketSubstatusModalVisible = false
    this.isUpdateTicketSubstatus = false
  }

  storeTicketReasonReset()
  {
    this.storeSetTicketReason({id:null, name:null, disabled:false})
    this.dtTicketReasonsModalVisible = false
    this.isUpdateClosingReason = false
  }

  storeClosingReasonReset(){
    // === closing reason
    this.storeSetClosingReason({id:null, name:null, description:null, disabled:false})
    this.dtClosingReasonsModalVisible = false
    this.isUpdateClosingReason = false
  }

  handleClose () {
    this.storeSetUserActionType(this.profileAction.Profile)
  }

  TemplateMaintenanceTitle()
  {
    return this.isUpdateTemplateMaintenance ? 'Modifier template de maintenance' : 'Créer un template de maintenance'
  }

  ClosingReasonModalTitle()
  {
    return this.isUpdateClosingReason ? this.$t(this.lblSetting.closingReasonEditTitle) : this.$t(this.lblSetting.closingReasonCreateTitle)
  }

  TicketSubstatusModalTitle()
  {
    return this.isUpdateTicketSubstatus ? this.$t(this.lblSetting.ticketSubstatusEditTitle) : this.$t(this.lblSetting.ticketSubstatusCreateTitle)
  }

  TicketReasonsModalTitle()
  {
    return this.isUpdateTicketReason ? this.$t(this.lblSetting.ticketReasonEditTitle) : this.$t(this.lblSetting.ticketReasonCreateTitle)
  }

  handleSaveClosingReasons()
  {
    console.log('handleSaveClosingReasons')
    this.dtIsRecording = true
    if(this.isUpdateClosingReason) {
      this.profileService.patchClosingReason(this.closingReason.id, {
        name:this.closingReason.name,
        description:this.closingReason.description
      }).then((response)=>{
        eventBus.$emit('CLOSING_REASON_REALOAD',{})
        this.storeClosingReasonReset()
        this.dtIsRecording = false
        this.dtClosingReasonsModalVisible = false
      })
    } else {
      this.profileService.createClosingReason({
        name:this.closingReason.name,
        description:this.closingReason.description
      }).then((response)=>{
        eventBus.$emit('CLOSING_REASON_REALOAD',{})
        this.storeClosingReasonReset()
        this.dtIsRecording = false
        this.dtClosingReasonsModalVisible = false
      })
    }
  }

  handleSaveTicketSubstatus()
  {
    this.dtIsRecording = true
    if(this.isUpdateTicketSubstatus) {
      this.profileService.patchTicketSubstatu(this.ticketSubstatus.id, {
        name:this.ticketSubstatus.name,
      }).then((response)=>{
        eventBus.$emit('TICKET_SUBSTATUS_REALOAD',{})
        this.storeTicketSubstatusReset()
        this.dtIsRecording = false
        this.dtTicketSubstatusModalVisible = false
      })
    } else {
      this.profileService.createTicketSubstatu({
        name:this.ticketSubstatus.name,
      }).then((response)=>{
        eventBus.$emit('TICKET_SUBSTATUS_REALOAD',{})
        this.storeTicketSubstatusReset()
        this.dtIsRecording = false
        this.dtTicketSubstatusModalVisible = false
      })
    }
  }

  handleSaveTicketReason()
  {
    this.dtIsRecording = true
    if(this.isUpdateTicketReason) {
      this.profileService.patchTicketReason(this.ticketReason.id, {
        name:this.ticketReason.name,
      }).then((response)=>{
        eventBus.$emit('TICKET_REASON_REALOAD',{})
        this.storeTicketReasonReset()
        this.dtIsRecording = false
        this.dtTicketReasonsModalVisible = false
      })
    } else {
      this.profileService.createTicketReason({
        name:this.ticketReason.name,
      }).then((response)=>{
        eventBus.$emit('TICKET_REASON_REALOAD',{})
        this.storeTicketReasonReset()
        this.dtIsRecording = false
        this.dtTicketReasonsModalVisible = false
      })
    }
  }

  handleDisableClosingReasons()
  {
    console.log('handleDisableClosingReasons')
    if(this.isUpdateClosingReason) {
      this.loadingDisabled = true
      this.profileService.patchClosingReason(this.closingReason.id, {
        disabled:!this.closingReason.disabled
      }).then((response)=>{
        eventBus.$emit('CLOSING_REASON_REALOAD',{})
        this.storeClosingReasonReset()
        this.loadingDisabled = false
        this.dtClosingReasonsModalVisible = false
      })
    }
  }


  handleDisableTicketSubstatus()
  {
    if(this.isUpdateTicketSubstatus) {
      this.loadingDisabled = true
      this.profileService.patchTicketSubstatu(this.ticketSubstatus.id, {
        disabled:!this.ticketSubstatus.disabled
      }).then((response)=>{
        eventBus.$emit('TICKET_SUBSTATUS_REALOAD',{})
        this.storeTicketSubstatusReset()
        this.loadingDisabled = false
        this.dtTicketSubstatusModalVisible = false
      })
    }
  }

  handleDisableTicketReason()
  {
    if(this.isUpdateTicketReason) {
      this.loadingDisabled = true
      this.profileService.patchTicketReason(this.ticketReason.id, {
        disabled:!this.ticketReason.disabled
      }).then((response)=>{
        eventBus.$emit('TICKET_REASON_REALOAD',{})
        this.storeTicketReasonReset()
        this.loadingDisabled = false
        this.dtTicketReasonsModalVisible = false
      })
    }
  }

  handleSaveTemplateMaintenance()
  {
    this.dtIsRecording = true
    eventBus.$emit('SET_ISLOADING_MODAL_TEMPLATE_MAINTENANCE',true)
    if(this.isUpdateTemplateMaintenance)
    {
      this.storeUpdateTemplateMaintenance(this.templateMaintenanceData.id).then(response=>{
        this.dtTemplateMaintenanceModalVisible = false
        this.templateMaintenanceData = null
        this.isUpdateTemplateMaintenance = false
        this.storeTemplateMaintenanceInitFields()
        eventBus.$emit('RELOAD_MAINTENANCE_TEMPLATE', {})
      }).catch(error=>{
        console.log({error})
      }).finally(()=>{
        this.dtIsRecording= false
      })
    } else {
      this.storeCreateTemplateMaintenance().then(response=>{
        this.dtTemplateMaintenanceModalVisible = false
        this.storeTemplateMaintenanceInitFields()
        eventBus.$emit('RELOAD_MAINTENANCE_TEMPLATE', {})
      }).catch(error=>{
        console.log({error})
      }).finally(()=>{
        this.dtIsRecording= false
      })
    }
  }

  handleSave () {
    switch (this.userActionType) {
      case this.profileAction.Profile:
        this.handleSaveProfile()
        break
      case this.profileAction.Signature:
        this.handleUpdateOwnSignature()
        break
      case this.profileAction.CharPb:
        this.handleSaveCharPb()
        break
      case this.profileAction.Attribute:
        this.handleSaveAttribute()
        break
      case this.profileAction.ATAttribute:
        this.handleSaveATAttribute()
        break
      case this.profileAction.AttachmentType:
        this.handleSaveAttachmentType()
        break
    }
  }

  handleSaveProfile () {
    if (this.isProfileUpdateAction) {
      this.handleUpdateMember()
    } else if (this.isUserUpdateAction) {
      this.handleUpdateOwnUser()
    } else {
      this.handleRecordMember()
    }
  }

  handleRecordMember () {
    this.storeRecordMember()
      .then(response => {
        this.dtProfileModalVisible = false
      })
      .catch(this.handleError)
      .finally(() => {
        this.dtIsRecording = false
      })
  }

  handleUpdateMember () {
    this.storeUpdateMember()
      .then(response => {
        this.storeResetMembers()
          .then((value) => {
          this.storeSetPaginationPage(0)
        })
        this.dtProfileModalVisible = false
      })
      .catch(this.handleError)
      .finally(() => {
        this.dtIsRecording = false
      })
  }

  handleUpdateOwnUser () {
    this.storeUpdateMember({own: true})
      .then(response => {
        this.storeResetUser()
        this.storeGetUserInfo()
        this.dtProfileModalVisible = false
      })
      .catch(this.handleError)
      .finally(() => {
        this.dtIsRecording = false
      })
  }

  handleUpdateOwnSignature () {
    this.storeUpdateSignature({signature: this.newSignature})
      .then(response => {
        this.storeSetUserInfo({signature: response.signature})
        this.storeResetUser()
        this.dtProfileModalVisible = false
      })
      .catch(this.handleError)
      .finally(() => {
        this.dtIsRecording = false
        // Todo already used in handle close, check if necessary here
        this.storeSetUserActionType(this.profileAction.Profile)
      })
  }

  handleSaveCharPb () {
    if (this.isAMUpdateAction) {
      this.handleUpdateCharPb()
    } else {
      this.handleRecordCharPb()
    }
  }

  handleRecordCharPb () {
    this.storeRecordCharPb()
      .then(response => {
        this.dtProfileModalVisible = false
        this.$router.push({
          path: '/profile/char-problem/' + response.id
        })
      })
      .catch(this.handleError)
      .finally(() => {
        this.dtIsRecording = false
      })
  }

  handleUpdateCharPb (changeEnabled: boolean = false) {
    if (changeEnabled) {
      this.storeSetCharPbByValue({enabled: !this.characterProblemToEdit.enabled})
    }
    this.storeUpdateCharPb()
      .then(response => {
        this.dtProfileModalVisible = false
      })
      .catch(this.handleError)
      .finally(() => {
        this.dtIsRecording = false
      })
  }

  handleSaveAttribute () {
    if (this.isAMUpdateAction) {
      this.handleUpdateAttribute()
    } else {
      this.handleRecordAttribute()
    }
  }

  handleSaveATAttribute () {
    if (this.isAMUpdateAction) {
      this.handleUpdateATAttribute()
    } else {
      this.handleRecordATAttribute()
    }
  }

  handleSaveAttachmentType () {
    if (this.isAMUpdateAction) {
      this.handleUpdateAttachmentType()
    } else {
      this.handleRecordAttachmentType()
    }
  }

  handleUpdateAttachmentType (changeEnabled: boolean = false) {
    if (changeEnabled) {
      this.storeSetAttachmentTypeByValue({enabled: !this.attachmentTypeToEdit.enabled})
    }
    this.storeUpdateAttachmentType()
      .then(response => {
        this.dtProfileModalVisible = false
      })
      .catch(this.handleError)
      .finally(() => {
        this.dtIsRecording = false
      })
  }

  handleRecordAttachmentType () {
    this.storeRecordAttachmentType()
      .then(response => {
        this.dtProfileModalVisible = false
        this.$router.push({
          path: '/profile/attachment-type/' + response.id
        })
      })
      .catch(this.handleError)
      .finally(() => {
        this.dtIsRecording = false
      })
  }

  handleUpdateAttribute () {
    this.storeUpdateAttribute()
      .then(response => {
        this.dtProfileModalVisible = false
      })
      .catch(this.handleError)
      .finally(() => {
        this.dtIsRecording = false
      })
  }

  handleRecordAttribute () {
    this.storeRecordAttribute()
      .then(response => {
        this.dtProfileModalVisible = false
      })
      .catch(this.handleError)
      .finally(() => {
        this.dtIsRecording = false
      })
  }

  handleUpdateATAttribute () {
    this.storeUpdateATAttribute()
      .then(response => {
        this.dtProfileModalVisible = false
      })
      .catch(this.handleError)
      .finally(() => {
        this.dtIsRecording = false
      })
  }

  handleRecordATAttribute () {
    this.storeRecordATAttribute()
      .then(response => {
        this.dtProfileModalVisible = false
      })
      .catch(this.handleError)
      .finally(() => {
        this.dtIsRecording = false
      })
  }

  handleError (error) {
    this.dtError = error
    this.dtErrorModalVisible = true
  }

  handleRemoveError () {
    this.dtErrorModalVisible = false
    this.dtError = null
  }
}

export default ProfileContainer



// WEBPACK FOOTER //
// ./src/containers/profile/index.ts